var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('step-base-form',{attrs:{"v-if":_vm.$t('lms.admin.forms.edit-step'),"step":_vm.step,"program":_vm.program,"group-id":_vm.groupId,"is-loading":_vm.isLoading,"is-error":_vm.isError},on:{"submit":_vm.handleSubmit}})}
var staticRenderFns = []

export { render, staticRenderFns }